function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import Tooltip from '../tooltip';
import Icon from '../icon';
import Button from '../button';
export default {
  name: buildComponentName('Popconfirm'),
  props: _objectSpread({}, Tooltip.props, {
    prefixCls: {
      type: String,
      default: 'ux-popover'
    },
    title: {
      type: String,
      default: ''
    },
    okText: {
      type: String,
      default: '确定' // default: 'Yes',

    },
    okType: {
      type: String,
      default: 'primary'
    },
    cancelText: {
      type: String,
      default: '取消' // default: 'No',

    } // isTrigger: {
    //   type: Boolean,
    //   default: true,
    // },

  }),
  data: function data() {
    return {
      innerVisible: false
    };
  },
  computed: {
    bindProps: function bindProps() {
      var $props = this.$props,
          innerVisible = this.innerVisible;
      return _objectSpread({}, $props, {
        // trigger: isTrigger ? 'click' : 'none',
        trigger: 'click',
        // placement: 'top',
        visible: innerVisible
      });
    }
  },
  methods: {
    setInnerVisible: function setInnerVisible(visible) {
      this.innerVisible = visible;
      this.$emit('visible-change', visible);
    },
    getTitle: function getTitle() {
      var $slots = this.$slots,
          title = this.title;
      return $slots.title || title;
    },
    onConfirm: function onConfirm(e) {
      this.setInnerVisible(false);
      this.$emit('confirm', e);
    },
    onCancel: function onCancel(e) {
      this.setInnerVisible(false);
      this.$emit('cancel', e);
    },
    renderOverlay: function renderOverlay() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          getTitle = this.getTitle,
          okText = this.okText,
          okType = this.okType,
          cancelText = this.cancelText,
          onConfirm = this.onConfirm,
          onCancel = this.onCancel;
      return h("div", [h("div", {
        "class": "".concat(prefixCls, "-inner-content")
      }, [h("div", {
        "class": "".concat(prefixCls, "-message")
      }, [h(Icon, {
        "attrs": {
          "type": "info_circle"
        }
      }), h("div", {
        "class": "".concat(prefixCls, "-message-title")
      }, [getTitle()])]), h("div", {
        "class": "".concat(prefixCls, "-buttons")
      }, [h(Button, {
        "on": {
          "click": onCancel
        },
        "attrs": {
          "size": "small"
        }
      }, [cancelText]), h(Button, {
        "on": {
          "click": onConfirm
        },
        "attrs": {
          "type": okType,
          "size": "small"
        }
      }, [okText])])])]);
    },
    onVisibleChange: function onVisibleChange(visible) {
      this.setInnerVisible(visible);
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        bindProps = this.bindProps,
        renderOverlay = this.renderOverlay,
        onVisibleChange = this.onVisibleChange;
    var on = {
      'visible-change': onVisibleChange
    };
    return h(Tooltip, {
      "props": _objectSpread({}, bindProps),
      "on": _objectSpread({}, on)
    }, [$slots.default, h("template", {
      "slot": "content"
    }, [renderOverlay()])]);
  }
};